import { render, staticRenderFns } from "./OptionSideBar.vue?vue&type=template&id=56bea350&scoped=true&"
import script from "./OptionSideBar.vue?vue&type=script&lang=ts&"
export * from "./OptionSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./OptionSideBar.vue?vue&type=style&index=0&id=56bea350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bea350",
  null
  
)

export default component.exports